export { CGUHeader } from "./sections/Header";
export {
	CGUSection1,
	CGUSection2,
	CGUSection3,
	CGUSection4,
	CGUSection5,
} from "./sections/Sections1-5";
export { CGUSection6, CGUSection7, CGUSection8 } from "./sections/Sections6-8";
export {
	CGUSection9,
	CGUSection9_1,
	CGUSection9_2,
	CGUSection10,
	CGUSection11,
	CGUSection12,
} from "./sections/Sections9-12";
export {
	CGUSection12_1,
	CGUSection12_2,
	CGUSection13,
	CGUSection14,
	CGUSection15,
	CGUSection16,
	CGUSection17,
	CGUSection18,
	CGUFooter,
} from "./sections/Sections12_1-18";
